// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__PGxQQ","banner__btnContainer":"Banner_banner__btnContainer__Vn9T2"};